import { EEidType } from '@signing-page/signing/types/enums/eid-type';

export class EIdService {
  private static readonly staticBaseUrl: string =
    process.env.VUE_APP_EID_API_URL || 'eid.ga-staging.com';

  public static criiptoRedirect(
    eid: EEidType,
    documentId: string,
    recipientId: string,
    authId: string
  ): void {
    const url = `https://${this.staticBaseUrl}/${this.getPath(
      eid
    )}/login?documentId=${documentId}&recipientId=${recipientId}&authId=${authId}`;
    window.location.assign(url);
  }

  public static getPath(eid: EEidType): string {
    switch (eid) {
      case EEidType.MitID:
        return 'bankid-mitid';
      case EEidType.NO:
        return 'bankid-no-v2';
      case EEidType.NemID:
        return 'bankid-dk';
      case EEidType.NemIDKeyFile:
        return 'bankid-dk-keyfile';
      case EEidType.NemIDOrg:
        return 'bankid-dk-org';
      case EEidType.SE:
        return 'bankid-se';
      case EEidType.BankIDFI:
        return 'bankid-fi';
    }
  }
}
